import React, {useMemo} from 'react';
import axios from 'src/common/axiosInstance';
import SharedCustomerFields from './SharedCustomerFields';
import CustomerContextView from './CustomerContextView';

// Host adapter owns authentication and the source API; shared UI never sees tokens.
const loadContext = (recordId, params, signal) => axios.get(
  `/customer-context/records/${encodeURIComponent(recordId)}`, { params, signal }
).then(({data}) => data.data);
const renderSharedFields = recordId => <SharedCustomerFields recordId={recordId} initiallyOpen />;
export default function CustomerContext(props) {
  const mailApi = useMemo(() => {
    const call = (method, path, data) => {
      const action = path.replace('/mail/', '');
      if (!['context','connections','templates','preview','send'].includes(action)) return Promise.reject(new Error('Open Mail to manage templates.'));
      const url = `/customer-context/records/${encodeURIComponent(props.recordId)}/mail/${action}`;
      return (method === 'get' ? axios.get(url, data) : axios.post(url, data)).then(({data})=>({data:data.data}));
    };
    return {get:(path,options)=>call('get',path,options),post:(path,data)=>call('post',path,data)};
  }, [props.recordId]);
  const whatsappApi = useMemo(()=>({
    get:(action,params)=>axios.get(`/customer-context/records/${encodeURIComponent(props.recordId)}/whatsapp/${action}`,{params}).then(r=>r.data.data),
    post:(action,data)=>axios.post(`/customer-context/records/${encodeURIComponent(props.recordId)}/whatsapp/${action}`,data).then(r=>r.data.data),
  }),[props.recordId]);
  return <CustomerContextView whatsappApi={whatsappApi} mailApi={mailApi} {...props} loadContext={loadContext} renderSharedFields={renderSharedFields} />;
}
